/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIProductionOrderStatusEnum } from './APIProductionOrderStatusEnum';
import {
    APIProductionOrderStatusEnumFromJSON,
    APIProductionOrderStatusEnumFromJSONTyped,
    APIProductionOrderStatusEnumToJSON,
} from './APIProductionOrderStatusEnum';
import type { APIPlanningEnum } from './APIPlanningEnum';
import {
    APIPlanningEnumFromJSON,
    APIPlanningEnumFromJSONTyped,
    APIPlanningEnumToJSON,
} from './APIPlanningEnum';

/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIProductionOrder
 */
export interface APIProductionOrder {
    /**
     * 
     * @type {string}
     * @memberof APIProductionOrder
     */
    readonly self: string;
    /**
     * 
     * @type {Date}
     * @memberof APIProductionOrder
     */
    startDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof APIProductionOrder
     */
    dueDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof APIProductionOrder
     */
    customerOrder?: string;
    /**
     * 
     * @type {string}
     * @memberof APIProductionOrder
     */
    article: string;
    /**
     * 
     * @type {Date}
     * @memberof APIProductionOrder
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof APIProductionOrder
     */
    readonly lastModifiedAt: Date;
    /**
     * 
     * @type {APIProductionOrderStatusEnum}
     * @memberof APIProductionOrder
     */
    status?: APIProductionOrderStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof APIProductionOrder
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof APIProductionOrder
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof APIProductionOrder
     */
    comment?: string;
    /**
     * 
     * @type {APIPlanningEnum}
     * @memberof APIProductionOrder
     */
    planning?: APIPlanningEnum | null;
    /**
     * 
     * @type {number}
     * @memberof APIProductionOrder
     */
    priority?: number | null;
}



/**
 * Check if a given object implements the APIProductionOrder interface.
 */
export function instanceOfAPIProductionOrder(value: object): value is APIProductionOrder {
    if (!('self' in value) || value['self'] === undefined) return false;
    if (!('article' in value) || value['article'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('lastModifiedAt' in value) || value['lastModifiedAt'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    return true;
}

export function APIProductionOrderFromJSON(json: any): APIProductionOrder {
    return APIProductionOrderFromJSONTyped(json, false);
}

export function APIProductionOrderFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIProductionOrder {
    if (json == null) {
        return json;
    }
    return {
        
        'self': json['self'],
        'startDate': json['start_date'] == null ? undefined : (new Date(json['start_date'])),
        'dueDate': json['due_date'] == null ? undefined : (new Date(json['due_date'])),
        'customerOrder': json['customer_order'] == null ? undefined : json['customer_order'],
        'article': json['article'],
        'createdAt': (new Date(json['created_at'])),
        'lastModifiedAt': (new Date(json['last_modified_at'])),
        'status': json['status'] == null ? undefined : APIProductionOrderStatusEnumFromJSON(json['status']),
        'amount': json['amount'],
        'description': json['description'] == null ? undefined : json['description'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'planning': json['planning'] == null ? undefined : APIPlanningEnumFromJSON(json['planning']),
        'priority': json['priority'] == null ? undefined : json['priority'],
    };
}

export function APIProductionOrderToJSON(value?: Omit<APIProductionOrder, 'self'|'created_at'|'last_modified_at'> | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'start_date': value['startDate'] == null ? undefined : ((value['startDate']).toISOString()),
        'due_date': value['dueDate'] == null ? undefined : ((value['dueDate']).toISOString()),
        'customer_order': value['customerOrder'],
        'article': value['article'],
        'status': APIProductionOrderStatusEnumToJSON(value['status']),
        'amount': value['amount'],
        'description': value['description'],
        'comment': value['comment'],
        'planning': APIPlanningEnumToJSON(value['planning']),
        'priority': value['priority'],
    };
}

